import React, { useState } from "react";
import { ReactNode } from "react";
import { Hidden, makeStyles } from "@material-ui/core";
import { Theme } from "src/theme";
import NavBar from "./NavBar";
import BottomNav from "./BottomNav";
import TopBar from "./TopBar";
import { HistorySection } from "src/views/upload/HistorySection";
import ResizePanel from "react-resize-panel";
interface DashboardLayoutProps {
  children?: ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
    maxWidth: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingBottom: 56,
    [theme.breakpoints.up("md")]: {
      paddingBottom: 0,
      paddingLeft: 304,
    },
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    display: "flex",
    minHeight: "100%",
    overflow: "auto",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  history: {
    minWidth: 400,
    minHeight: "100%",
    // [theme.breakpoints.up("sm")]: {
    //   borderLeft: "1px solid rgba(0,0,0,.1)",
    // },
  },
}));

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState<boolean>(false);

  return (
    <div className={classes.root}>
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Hidden smUp>
              <TopBar />
            </Hidden>
            {children}
            <div className={classes.history}>
              <Hidden smUp>
                <HistorySection />
              </Hidden>
              <Hidden smDown>
                <ResizePanel direction="w">
                  <HistorySection />
                </ResizePanel>
              </Hidden>
            </div>
          </div>
        </div>
      </div>

      {/* <Hidden mdUp>
        <BottomNav />
      </Hidden> */}
    </div>
  );
};

export default DashboardLayout;
